module.exports = __webpack_public_path__ + "static/img/menu4.fdf18611.png";